import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import s from './EserviceError.css';
import { connect } from 'react-redux';

class EserviceError extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <Modal show>
        <Modal.Header className="bg-warning" closeButton={false}>
          <Modal.Title>Tymczasowa niedostępność usługi.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <center>Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.</center>
          <br /><br />
          <Button className="btn btn-warning pull-right" href="/">OK</Button>
          <br /><br />
        </Modal.Body>
      </Modal>
    );
  }
}

export default withStyles(s)(EserviceError);




// WEBPACK FOOTER //
// src/routes/eserviceError/EserviceError.js